import { makeVar } from '@apollo/client'

export const alertOkModalVar = makeVar<{
  alertTitle?: string
  alertMessage?: string
}>({
  alertTitle: undefined,
  alertMessage: undefined,
})
